var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.uiconfig.layoutType,{ref:"layout",tag:"component",attrs:{"config":_vm.uiconfig,"dictData":_vm.globalConfig.dictData,"moduleMethod":_vm.globalConfig.userModuleMethod},on:{"doAction":_vm.doAction}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/masterplate/layouttemplate.vue